import React, { useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import SaveButton from "components/buttonsComponent/SaveButton";
import DownloadIcon from "@mui/icons-material/Download";
import { width } from "../../../node_modules/@mui/system/index";
import DownloadButton from "components/buttonsComponent/DownloadButton";
import { FaDownload } from "react-icons/fa";
import UserIdButton from "components/buttonsComponent/UserIdButton";
import ReportCountdownButton from "components/buttonsComponent/ReportCountdownButton";

const DownloadPostReviewReports = ({
  onNext,
  standardName = "GRI",
  Standard = "Standard",
  showReportCountdownButton = false,
  showSaveButton = true,
}) => {
  const [isDownloaded, setIsDownloaded] = useState(false);
  const formImageUrl = "../../assets/images/GriCustomizeForm.png";

  const handleDownloadClick = () => {
    const link = document.createElement("a");
    link.href = formImageUrl;
    link.download = "Post_Review_Reports.docs";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setIsDownloaded(true);
  };

  const handleNext = () => {
    console.log("Moving to next step...");
    if (onNext) {
      onNext();
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          className="standards-header"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            [(theme) => theme.breakpoints.down("sm")]: {
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "stretch",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: "center",
            }}
          >
            {showReportCountdownButton && <ReportCountdownButton />}
            {showSaveButton && (
              <SaveButton
              // onClick={handleSave}
              >
                Save
              </SaveButton>
            )}
            {/* <SaveButton
            // onClick={handleSave}
            >
              Save
            </SaveButton> */}
            <UserIdButton />
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} className="mx-2">
        <Typography
          variant="h6"
          sx={{
            fontFamily: "DM Sans",
            fontWeight: 800,
            fontSize: "24px",
            lineHeight: "42px",
            color: "#02462E",
            marginBottom: "24px",
          }}
        >
          Download Post Review Reports
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "32px",
              color: "#28A745",
              marginBottom: "8px",
            }}
          >
            Your Post Review Reports are Ready!
          </Typography>

          <Typography
            sx={{
              fontFamily: "DM Sans",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "26px",
              color: "#A3AED0",
              marginBottom: "24px",
              width: "30%",
            }}
          >
            Your {standardName} {Standard} Reports are Ready, Click on Download
            Button to Download!
          </Typography>
          <DownloadButton
            title="Download Post Review Reports"
            onClick={handleDownloadClick}
            isDownloaded={isDownloaded}
            endIcon={<FaDownload sx={{ fontSize: 20 }} />}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default DownloadPostReviewReports;
